import { Link, Text } from '@farmersdog/corgi-x';
import { Chevron } from '@farmersdog/corgi-x/icons';

import styles from './BreedsLinks.css';

import type { BreedRouteData } from './getBreedRoutesFromRoutes';

interface BreedsLinksProps {
  routes: BreedRouteData[];
}

export function BreedsLinks({ routes }: BreedsLinksProps) {
  return (
    <ul aria-label="Breed page links" className={styles.list}>
      {routes.map(({ url, name }) => (
        <Text as="li" variant="article-20" className={styles.item} key={url}>
          <Link to={url} baseColor="kale">
            {name}{' '}
            <Chevron className={styles.chevron} baseColor="Carrot2" size={24} />
          </Link>
        </Text>
      ))}
    </ul>
  );
}
